import { MiaLayoutController } from './mia-layout.controller'

/* @ngInject */
function miaLandingPageLayout () {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: '/core/directives/mia-layout/mia-layout.template.html?$$REVISION$$',
    controller: MiaLayoutController
  }
}

export { miaLandingPageLayout }
